import { Button, Tooltip } from '@dexma/ui-components';
import { ConfigFieldType } from 'adapter/in/common/form/types';
import { getOptionsFormByWidgetType } from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Options';
import { StyledActionsMenuWrapper } from 'adapter/in/dashboards/pages/Widget/ActionsMenu/style';
import i18n from 'asset/translation';
import { WidgetType } from 'domain/entity/widget';
import React, { ReactElement, useState } from 'react';

type WidgetMenuProps = {
    onDelete: () => void;
    onEdit: (tab: ConfigFieldType) => void;
    isEditDisabled: (tabPane: ConfigFieldType) => boolean;
    widgetType: WidgetType;
    showOptions: boolean;
};
export const WidgetActionsMenu = (props: WidgetMenuProps): ReactElement => {
    const { onDelete, onEdit, isEditDisabled, widgetType, showOptions } = props;
    const hasOptions = getOptionsFormByWidgetType(widgetType).length > 0;
    const [showTooltipData, setShowTooltipData] = useState(false);
    const [showTooltipOptions, setShowTooltipOptions] = useState(false);
    return (
        <StyledActionsMenuWrapper data-testid='widget-menu'>
            <Tooltip
                destroyTooltipOnHide
                open={showTooltipData}
                title={`${i18n.t('common.edit')} ${i18n.t('widgets.widgetMenu.data')}`}
                position='top'
            >
                <Button
                    data-testid='edit-data'
                    onClick={() => {
                        setShowTooltipData(false);
                        onEdit(ConfigFieldType.DATA);
                    }}
                    onMouseEnter={() => setShowTooltipData(true)}
                    onMouseLeave={() => setShowTooltipData(false)}
                    iconBefore='settings'
                    isDisabled={isEditDisabled(ConfigFieldType.DATA)}
                    isCircle
                />
            </Tooltip>
            {showOptions && hasOptions && (
                <Tooltip
                    destroyTooltipOnHide
                    open={showTooltipOptions}
                    title={`${i18n.t('common.edit')} ${i18n.t('widgets.widgetMenu.options')}`}
                    position='top'
                >
                    <Button
                        data-testid='edit-options'
                        onClick={() => {
                            setShowTooltipOptions(false);
                            onEdit(ConfigFieldType.OPTIONS);
                        }}
                        onMouseEnter={() => setShowTooltipOptions(true)}
                        onMouseLeave={() => setShowTooltipOptions(false)}
                        iconBefore='edit'
                        isDisabled={isEditDisabled(ConfigFieldType.OPTIONS)}
                        isCircle
                    />
                </Tooltip>
            )}
            <Tooltip title={i18n.t('common.delete')} position='top'>
                <Button data-testid='delete-widget' onClick={() => onDelete()} iconBefore='delete' variant='destructive' isCircle />
            </Tooltip>
        </StyledActionsMenuWrapper>
    );
};

export default WidgetActionsMenu;
